import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './utils/pwaInstall'; // captures beforeinstallprompt on app boot

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA and offline functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('PWA: Service worker registered successfully!');
    console.log('PWA: App is ready for offline use');
    
    // Request caching of all app assets
    if (registration.active) {
      registration.active.postMessage({ type: 'CACHE_ALL' });
    }
  },
  onUpdate: (registration) => {
    console.log('PWA: New version available, updating...');
    // Auto-update the service worker
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // Reload after a short delay to get the new version
      setTimeout(() => window.location.reload(), 1500);
    }
  }
});
